import { gql } from "@apollo/client";

export const GET_APP_SETTINGS_COUNT = gql`
  {
    consumerAppSettingsCount
  }
`;